import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { DataService } from "../../core/services/data.service";
import { UsuarioService } from "../../recursos-humanos/usuarios/shared/usuario.service";

@Injectable()
export class AuthService {
    isLoggedIn: boolean = false;

    // store the URL so we can redirect after logging in
    redirectUrl: string;

    private tenants: string[];
    private contasDomain: string;

    constructor(
        private _usuarioService: UsuarioService,
        private _dataService: DataService,
        private _router: Router
    ) {
        this.tenants = this._dataService.getTenants();
        this.contasDomain = this._dataService.getContasDomain();
    }

    navigateTo(pathTo: string, param?: any) {
        const tenantName: any = this.getTenantUrl();

        let url = this._router.url;
        if (url.indexOf("visitante") === -1) {
            pathTo = tenantName.concat("/" + pathTo);
        } else{
            pathTo = tenantName.concat("/visitante/" + pathTo);
        }

        if (param) {
            if (param.length) {
                let params: any[] = param;
                params.unshift(pathTo);
                this._router.navigate(params);
            } else {
                this._router.navigate([pathTo, param]);
            }
        } else {
            this._router.navigate([pathTo]);
        }
    }

    logout(): void {
        this.isLoggedIn = false;
        localStorage.clear();
        sessionStorage.clear();

        let exp: string = this._dataService.getCookieName();

        document.cookie = exp + '=123; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.geosiap.net';
        window.location.assign(this.contasDomain + "/logout");
    }

    checkCookie() {
        // if (process.env.ENV !== 'production' && process.env.ENV !== 'staging') {
        //    document.cookie = "staging_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpZCI6NjYsImVtYWlsIjoiZnJvdGFzQGV4bGEuY29tLmJyIiwidXNlcm5hbWUiOiJmcm90YXMiLCJub21lIjoiVXN1w6FyaW8gVGVzdGUgRnJvdGFzIiwiZm90b191cmwiOm51bGx9.fihDuWnIEHut1_i1E1SWyhTGMEWS-2eV51MjQeA8QMCa74sEYNcEukiO3y-AfXx4oJFvNIlfHYdE5gvg_xF3capge-7qDP-7i4QtR0m1la1-xF8uN9IOLfz5Deb3RnZcv8Px7pw-hOk2AKMTFkWx2To73V3fq6YROqsuKnGtCP9xH3Jj9w62YjeTJPm8oEomKBS85OBfmNmRQCJpC6rQpuGacBbtrcarvAc8irOQya3fg76uRO6OFEXMFYOCU4E1Ehgc39B5GiHSlaRBLGbYuzw4ZboH7ZXs61RC9Kk7d741RFkWngmM0QCHilzIkkGlYI2SjldtJaMtORLdLlNGNA";
        // }

        const cookie:any = this.getCookieToken();
        if (!cookie) {
            this.isLoggedIn = false;
            localStorage.clear();
            sessionStorage.clear();

            this.redirectToAccountPage();
        } else {
            const storageToken = this._usuarioService.getStorageToken();
            if (!storageToken) {
                const l = this.redirectUrl.split("/");
                if (l.length) {
                    this.redirectUrl = "/" + l[1];
                }
                this._usuarioService.getCredential(cookie);
            } else {
                this._dataService.setToken(storageToken);
            }

            this.isLoggedIn = true;
            this.navigateTo(this.redirectUrl);
        }
    }

    private redirectToAccountPage() {
        const r = this.contasDomain + "/login?return_to=" + window.location.href;
        window.localStorage.setItem('redirect', 'true');
        window.location.assign(r);
    }

    private getTenantUrl() {
        let url: string = this._router.url,
            tenants: any = this.tenants,
            findTenantName: string,
            findProjectIndex: number,
            x: any, lenX: any;

        for (x = 0, lenX = tenants.length; x < lenX; x++) {
            findProjectIndex = url.indexOf("/" + tenants[x] + "/");
            if (findProjectIndex !== -1) {
                findTenantName = tenants[x];
                return findTenantName;
            }
        }

        return '';
    }

    private getCookieToken() {
        let cookie: any = document.cookie;
        let cookie2: any = null;
        if (cookie) {
            // cookie = cookie.split("=");
            // cookie2 = cookie[1];
            cookie = cookie.split(";");
            let x: number, lenX:number;
            const cookieName = this._dataService.getCookieName();
            for(x = 0, lenX = cookie.length; x < lenX; x++) {
                if (cookie[x].search(cookieName) !== -1) {
                    cookie2 = cookie[x].split("=");
                    cookie2 = cookie2[1];
                    break;
                }
            }
        }
        return cookie2;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/services/auth.service.ts
 **/